import { logErrorsToBackendFactory, exceptionHandlerFactory } from '../angular-errors/seq_error_logger';
import { SeqLoggingTokenService } from '../angular-errors/SeqLoggingTokenService';
import {PlaceNameSearchService, SearchService} from '../services/search';
import {ActiveCtrl} from '../controllers/active';
import {SearchCtrl} from '../controllers/search';
import {GeoAppCtrl} from '../controllers/smap/geoapp';
import {SearchItem} from '../controllers/geoapp';
import {ModalInstanceCtrl} from '../controllers/modalinstance';
import {LayerQueryService} from "../services/layer_query";
import {MapShareCtrl, MapShareService} from "../services/MapShareAPI";
import {ToastService} from "../services/ToastService";
import {LcrAnalyticsEvent} from "../directives/event-tracking-directives";
import {UsageLoggingService} from "../services/UsageLoggingService";
import {PrintCtrl, PrintService} from "../controllers/print";
import {MapView} from "../directives/map-view-directive";
import {QueueService} from "../services/queue";
import {LtToolbar} from "../utility/toolbar";
import {SettingsCtrl} from "../controllers/settings";
import {SettingsService} from "../services/settings";
import {_F} from "../utility/func";
import {LegendService} from "../services/legend";
import {OEAreaQueryService} from "../services/oe_area_query";
import {SMapAppConfig} from "../services/app-config/smap-app-config";
import {LayerSelectorCtrl} from "../controllers/oe/layer-selector";
import {CustomLayerCtrl} from "../controllers/oe/custom-layer";
import {CustomLayers} from "../services/custom-layer-service";
import {LayerSettingsCtrl} from "../controllers/oe/layer-settings";
import {ErrorColour} from "../directives/error-colour";
import {TileLoadIndicator} from "../directives/tile-load-indicator";
import {OENavCtrl} from "../controllers/oe/nav";
import {AreaQueryChartCtrl} from "../controllers/areaQueryChartCtrl";
import {IsIndeterminate} from "../directives/indeterminate";
import {LayerGroupCtrl} from "../controllers/oe/layer-group";
import {LoggedInClick} from "../directives/logged-in-click";
import {LoginModalCtrl} from "../controllers/oe/login-modal-ctrl";
import {LoginService} from "../services/oe/login-service";
import {WfsResultsCtrl} from "../controllers/oe/wfs-results";
import {ContextFeatureMarkupService} from "../services/oe/feature_markup_service";
import {FeaturesControl} from "../controllers/features";
import {BarChartCompact} from "../directives/visualisation/bar-chart-compact";
import {LayerPickerCtrl} from "../controllers/LayerPicker";
import {Toast} from "../directives/toast";
import {FeatureState} from "../services/feature_state";
import {AreaReportCtrl} from "../controllers/area_report";
import {PinExtraDataService} from "../services/pin-extra-data-service";
import {PointQueryFeatureService} from "../services/point-query-feature-service";
import {TouchResize} from "../directives/touch-resize";
import {LatLon} from "../filter/LatLon";
import {RestfulSavedFeatureService} from "../services/features-api/restful_saved_feature_service";
import {SavedFeaturesCtrl} from "../controllers/saved_features";
import {OnEnter} from "../directives/on-enter";
import {ScrollIf} from "../directives/scroll-if";
import {IconForClass} from '../filter/IconForClass';
import {SiblingTable} from "../directives/sibling-table";
import {ReportTable} from "../directives/report-table";
import {SmapFeaturesPaneControl} from "../controllers/smap/SmapFeaturesPaneControl";
import {SMapPointReport} from "../components/SMapPointReport";
import {SiblingResult} from "../components/SiblingResult";
import {PointReportList} from "../components/PointReportList";
import {PointAttributes} from "../components/PointAttributes";
import {EditTitleComponent} from "../components/EditTitleComponent";
import {TourService} from "../services/TourService";
import {TileErrorMonitoringService} from "../services/tile-error-monitoring";
import {StubReportPresenter} from "../services/oe/report-presenter/StubReportPresenter";
import {SmuFactsheetService} from "../services/smap/smu-factsheet-service";
import {ExtraPointQueryAttributes} from "../components/ExtraPointQueryAttributes";
import {MetadataService} from "../services/metadata";
import {MultiMetadataComponent} from "../components/MultiMetadataComponent";
import {ReportFromUrlService} from "../services/smap/report-from-url-service";
import {LayerTreeManipulationService} from "../services/oe/layer-tree-manipulation";
import {SmapPortalServices} from "../lt-ng/smap-portal-services";
import {EnvironmentalSusceptibilityResult} from "../components/EnvironmentalSusceptibilityResult";
import {ClickOnInit} from "../directives/click-on-init";
// import {PinsCtrl} from '../controllers/pins';
// import {PinService} from 'src/services/PinApi';

export module appPage {
	import CustomLayerService = CustomLayers.CustomLayerService;

	interface ParentWithPageScope extends ng.IScope {
		$parent: ParentWithPageScope;
		page: number;
		items: SearchItem[];
	}
	interface SearchPaginationScope extends ng.IScope {
		totalItems: number;
		currentPage: number;
		maxSize: number;
		bigTotalItems: number;
		bigCurrentPage: number;
		itemsPerPage: number;
		$parent: ParentWithPageScope;
		setPage: (pageNo: number) => void;
		pageChanged: () => void;
	}
	class SearchPaginationCtrl {
		public static $inject = ['$scope', '$log'];
		constructor($scope: SearchPaginationScope, $log: ng.ILogService) {
			$scope.totalItems = Math.min($scope && $scope.$parent &&
				$scope.$parent.$parent && $scope.$parent.$parent.items &&
				$scope.$parent.$parent.items.length || 100, 100);
			$scope.currentPage = 1;

			$scope.setPage = function(pageNo) {
				$scope.currentPage = pageNo;
			};

			$scope.pageChanged = function() {
				$log.log('Page changed to: ' + $scope.currentPage);
				//$log.log('SCOPE', $scope);
				$scope.$parent.$parent.page = $scope.currentPage;
			};

			$scope.maxSize = 5;
			$scope.itemsPerPage = 10;
			$scope.bigTotalItems = 100;
			$scope.bigCurrentPage = 1;
		}
	}
	export function init(reportService: ng.Injectable<Function>, fragEnabled: boolean = false): void {
		let dependencies = [];

		// const isMapPage = !!document.querySelector('.page-map');

		dependencies = dependencies.concat(['ltMapDirective',
			'autocomplete',
			'treeControl',
			'ui.bootstrap',
			'ui.bootstrap.pagination',
			'ngResource',
			'ngSanitize',
			'ngPasswordStrength',
			'ngAnimate']);


		if (fragEnabled) {
			dependencies.push('frag');
		}

		const map = angular.module('map', dependencies);

		map.filter("sanitize", ['$sce', function($sce) {
				return function(htmlCode){
					return $sce.trustAsHtml(htmlCode);
				}
			}])
			.config(['$locationProvider', function($locationProvider) {
				$locationProvider.html5Mode({
					// Leave this in because otherwise it breaks Glossary links!
					enabled: true,
					requireBase: false,
					rewriteLinks: false
				}).hashPrefix('!');
			}])
			.filter("uom", function () {
				return function (value, uom) {
					if (value !== null && value !== undefined) {
						return `${value}${uom}`;
					}
					return '';
				}
			})
            .service('reportPresenterService', StubReportPresenter)
            .service('seqLoggingTokenService', SeqLoggingTokenService)
            .factory('logErrorsToBackend', logErrorsToBackendFactory)
            .factory('$exceptionHandler', exceptionHandlerFactory)
			.factory('errorHttpInterceptor', ['$q', function ($q : ng.IQService) {
                return {
                    'request': function (request) {
                        if (request.url.indexOf('/api') === 0 && request.transformResponse && request.transformResponse.push) {
                            request.transformResponse.push((data, headersGetter, status) => {
                                if (status == 403) {
                                    console.log('403 error, is user logged in?');
                                    console.log(request);
                                    console.log(data);
                                    console.log(status);
                                }

                                return data;
                            });
                        }
                        return request;
                    },
                    'response': function (response) {
                        // intercept error responses
                        if (typeof  response.data == 'object' && response.data['error']) {
                            return $q.reject(response.data);
                        }
                        return response;
                    }
                }
            }])
			.run(['treeConfig', function (treeConfig) {
				treeConfig.templateUrl = 'angular-tree-control.html';
			}])
			.config(['$httpProvider', function ($httpProvider : ng.IHttpProvider) {
				if (fragEnabled) {
					$httpProvider.interceptors.push('authHttpInterceptor');
				}
				$httpProvider.interceptors.push('errorHttpInterceptor');
			}])
			.filter('htmlToPlainText', () => {
				return _F.htmlToPlaintext
			})
			.filter('replaceUnicode', () => {

				return (val) => {
					if (typeof val === "string") {
						// replaces a microsoft em dash with a unicode em dash
						// see https://doremifaso.ca/archives/unicode/latin1.html
						// and https://doremifaso.ca/archives/unicode/named-entities.html
						return val.replace('\u0097', '\u2014');
					}

					return val;
				}
			})
			.filter('latLon', () => LatLon)
			.filter('m2ToHectares', () => {
				return (squareMetres) => {
					const ha = _F.getHectaresRounded(squareMetres);
					if (ha < 1 && squareMetres > 0) {
						return '< 1';
					}
					return ha;
				}
			})
            .factory('ltConfiguration', () => (window as any).LTConfiguration || {})
			.service('smuFactsheetService', SmuFactsheetService)
            .service('reportFromUrlService', ReportFromUrlService)
			.service('appConfig', SMapAppConfig)
			.service('portalServices', SmapPortalServices)
			.service('usageLoggingService', UsageLoggingService)
			.service('queueService', QueueService)
			// .service('pinService', PinService)
			.directive('scrollIf', ScrollIf.factory())
			.directive('lcrAnalyticsEvent', LcrAnalyticsEvent.factory())
			.directive('ltTileLoadIndicator', TileLoadIndicator.factory())
			.directive('ltMapView', MapView.factory())
			.directive('ltToolbar', LtToolbar.factory())
			// .directive('ltTreeMap', TreeMap.factory())
			.directive('ltBarChartCompact', BarChartCompact.factory())
			.directive('errorColour', ErrorColour.factory())
			.directive('isIndeterminate', IsIndeterminate.factory())
            .directive('touchResize', TouchResize.factory())
			.directive('onEnter', OnEnter.factory())
			.service('loginService', LoginService)
			.service('tourService', TourService)
			.directive('loggedInClick', LoggedInClick.factory())
            .directive('clickOnInit', ClickOnInit.factory())
			.controller('loginModalCtrl', LoginModalCtrl)
			.service('toastService', ToastService)
			.service('reportService', reportService)
			.directive('toast', Toast.factory())
            .service('placeNameSearchService', PlaceNameSearchService)
			.service('searchService', SearchService)
			.service('legendService', LegendService)
			.service('mapShareService', MapShareService)
			.service('layerQueryService', LayerQueryService)
			.service('areaQueryService', OEAreaQueryService)
			.service('settingsService', SettingsService)
			.service('customLayerService', CustomLayerService)
			.controller('modalInstanceCtrl', ModalInstanceCtrl)
			.controller('searchPaginationCtrl', SearchPaginationCtrl)
			.controller('geoAppCtrl', GeoAppCtrl)
			.controller('layerGroupCtrl', LayerGroupCtrl)
			.service('contextFeatureMarkupService', ContextFeatureMarkupService)
			.service('pinExtraDataService', PinExtraDataService)
			.controller('wfsResultsCtrl', WfsResultsCtrl)
			.service('pointQueryFeatureService', PointQueryFeatureService)
			.controller('layerSelectorCtrl', LayerSelectorCtrl)
			.controller('layerSettingsCtrl', LayerSettingsCtrl)
			.controller('customLayerCtrl', CustomLayerCtrl)
			.controller('searchCtrl', SearchCtrl)
			.controller('activeCtrl', ActiveCtrl)
			.controller('navCtrl', OENavCtrl)
			.service('printService', PrintService)
			.controller('printCtrl', PrintCtrl)
			.controller('mapShareCtrl', MapShareCtrl)
			.controller('areaReportCtrl', AreaReportCtrl)
			.directive('siblingTable', SiblingTable.factory())
			.filter('iconForClass', () => IconForClass)
			.directive('reportTable', ReportTable.factory())
			.controller('areaQueryChartCtrl', AreaQueryChartCtrl)
			.controller('settingsCtrl', SettingsCtrl)
			.controller('layerPickerCtrl', LayerPickerCtrl)
			.service('savedFeatureService', RestfulSavedFeatureService)
            .service('layerTreeManipulationService', LayerTreeManipulationService)
            .service('featureState', FeatureState)
            .service('metadataService', MetadataService)
			.controller('savedFeaturesCtrl', SavedFeaturesCtrl)
            .controller('featuresPaneCtrl', SmapFeaturesPaneControl)
			.controller('featuresCtrl', FeaturesControl)
            // .controller('pinsCtrl', PinsCtrl)
			.component('editTitle', new EditTitleComponent())
			.component('pointReportList', new PointReportList())
			.component('siblingResult', new SiblingResult())
			.component('environmentalSusceptibilityResult', new EnvironmentalSusceptibilityResult())
			.component('pointAttributes', new PointAttributes())
			.component('extraPointQueryAttributes', new ExtraPointQueryAttributes())
			.component('smapPointReport', new SMapPointReport())
            .component('multiMetadata', new MultiMetadataComponent());
	}
}
